import { APICore } from './apiCore'

const api = new APICore()

function addTranslation (params) {
  const baseUrl = '/translation-ai'
  return api.create(baseUrl, params)
}

export { addTranslation }
